import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Tag, Layers } from 'lucide-react'

interface ShareBarsProps {
  title: string
  description: string
  kind: 'brand' | 'category'
  data: Array<{ label: string; clicks: number; percentage: number }> | undefined
  isLoading: boolean
}

export function ShareBars({ title, description, kind, data, isLoading }: ShareBarsProps) {
  const Icon = kind === 'brand' ? Tag : Layers

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Icon className="h-5 w-5" />
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-6 w-full" />
            ))}
          </div>
        ) : !data || data.length === 0 ? (
          <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
            No click data yet — people haven't clicked a search result in this period.
          </div>
        ) : (
          <div className="space-y-2">
            {data.slice(0, 10).map((r) => (
              <div key={r.label} className="group">
                <div className="mb-0.5 flex items-center justify-between text-xs">
                  <span className="truncate font-medium" title={r.label}>
                    {r.label}
                  </span>
                  <span className="tabular-nums text-muted-foreground">
                    {r.clicks} · {r.percentage.toFixed(1)}%
                  </span>
                </div>
                <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full rounded-full bg-primary transition-all"
                    style={{ width: `${r.percentage}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
